var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18m3.9 12.915a.75.75 0 0 1-1.065.045l-3.75-3.405a.75.75 0 0 1-.21-.555V7.875a.75.75 0 1 1 1.5 0v3.795l3.473 3.188a.75.75 0 0 1 .052 1.057"
  })));
};
export default SvgClock;